<div class="container">
    <h1 class="page-title"
    [helpCenterButton]="permissionCode" [lang]="currentLang"
    [helpCenterDownloadButton]="permissionCode" [position]="'inline'" [lang]="currentLang">
    <span class="icon"><i class="fas fa-envelope"></i></span>{{ 'NotificationSubscribtion.Header' | translate }}</h1>
  <p-card>
    <div *ngIf="isShowAddSubscribtion">
      <ng-template pTemplate="title">
          <span>{{ 'NotificationSubscribtion.SubHeader' | translate }}</span>
      </ng-template>
      <form [formGroup]="notifyForm">
          <div class="p-fluid formgrid grid">
              <!-- <div class="field col-6">
                  <label>{{ 'NotificationSubscribtion.Form.Email' | translate }}</label>
                  <input pInputText type="text" [(ngModel)]="email" [ngModelOptions]="{standalone: true}" />
              </div> -->
              <!-- <div class="field col-6"></div> -->
              <div class="col-12 md:col-6 lg:col-6 mb-3">
                  <label>{{ 'NotificationSubscribtion.Form.NotificationType' | translate }}</label>
                  <p-multiSelect [options]="eventTypeOptions" [(ngModel)]="selectedEventType" formControlName="eventType"
                      optionLabel="text" optionValue="value" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                      (onChange)="checkPersonalEmailSubscriptionStatus($event)"></p-multiSelect>
                  <div *ngIf="submitted && f.eventType.errors" class="errors">
                      <div *ngIf="f.eventType.errors.required" class="p-invalid">{{ 'NotificationSubscribtion.Form.NotificationType' | translate }} is
                          required</div>
                  </div>
              </div>
              <div *ngIf="isShowTenant" class="col-12 md:col-6 lg:col-3 mb-3">
                  <label>{{ 'NotificationSubscribtion.Form.Tenant' | translate }}</label>
                  <p-multiSelect [options]="tenantOptions" [(ngModel)]="selectedTenant" [ngModelOptions]="{standalone: true}" optionLabel="tenantName" optionValue="tenantCode" [showToggleAll]="false"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}" (onChange)="getOrgOptions($event)">
                  </p-multiSelect>
              </div>
              <div *ngIf="isShowFacility" class="col-12 md:col-6 lg:col-3 mb-3">
                  <label>{{ 'NotificationSubscribtion.Facility' | translate }}</label>
                  <p-multiSelect [options]="facilityOptions" [(ngModel)]="selectedFacility" [ngModelOptions]="{standalone: true}" optionLabel="optionDesc" optionValue="optionCode" [showToggleAll]="false"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                  </p-multiSelect>
              </div>
              <div *ngIf="isShowForwarder" class="col-12 md:col-6 lg:col-3 mb-3">
                  <label>{{ 'NotificationSubscribtion.Forwarder' | translate }}</label>
                  <laas-multiSelect [options]="forwarderOptions" [(ngModel)]="selectedForwarder" [virtualScroll]="true" [virtualScrollItemSize]="59.2" [ngModelOptions]="{standalone: true}" optionLabel="text" optionValue="value" [showToggleAll]="false" [disabled]="isForwarderDisabled"
                      placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                  </laas-multiSelect>
              </div>
              <div *ngIf="isShowCustomer" class="col-12 md:col-6 lg:col-3 mb-3">
                  <label>{{ 'NotificationSubscribtion.Customer' | translate }}</label>
                  <laas-customer-dropdown [isMultiple]="true" [showLabel]="false" [(ngModel)]="selectedCustomer" [ngModelOptions]="{standalone: true}">
                  </laas-customer-dropdown>
              </div>
              <div *ngIf="isShowOrgId" class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'NotificationSubscribtion.Org' | translate }}</label>
                <laas-multiSelect [options]="orgIdOptionsBySelectedTenant" [(ngModel)]="selectedOrgId" [virtualScroll]="true" [virtualScrollItemSize]="59.2" [showToggleAll]="false"
                  [ngModelOptions]="{standalone: true}" optionLabel="optionDesc" optionValue="optionCode" appendTo="body"
                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                </laas-multiSelect>
              </div>
              <div *ngIf="isShowAttachFile" class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'NotificationSubscribtion.Form.IsSplitFile' | translate }}</label>
                <p-dropdown appendTo="body" [options]="fileTypeOptions" [(ngModel)]="selectedFileType" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" >

                </p-dropdown>
              </div>
              <div *ngIf="!isDisabledPersonalSubscription" class="col-12 md:col-6 lg:col-3 mb-3">
                <label>{{ 'NotificationSubscribtion.Form.IndiOrGroup' | translate }}</label>
                <div>
                  <p-dropdown appendTo="body" [options]="isByOwnerOptions" [(ngModel)]="isByOwner" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                  [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" >
                  </p-dropdown>
                </div>
              </div>
          </div>
          <div class="grid">
              <div class="col">
                  <button (click)="addBtnClick($event)" pButton pRipple label="{{ 'Common.Button.Add' | translate }}"></button>
                  <button (click)="reset()" pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" class="p-button-secondary ml-5"></button>
              </div>
          </div>
      </form>
      <p-card>
          <p-accordion>
              <p-accordionTab header="{{ 'NotificationSubscribtion.Form.Search' | translate }}" [(selected)]="isOpenFilter">
                  <form>
                      <div class="p-fluid formgrid grid">
                          <div class="field col-6">
                              <label>{{ 'NotificationSubscribtion.Form.NotificationType' | translate }}</label>
                              <p-dropdown [options]="filterEventTypeOptions" [(ngModel)]="formParam.eventType" [ngModelOptions]="{standalone: true}" optionLabel="text" optionValue="value"></p-dropdown>
                          </div>
                          <div class="field col-6">
                              <label>{{ 'NotificationSubscribtion.Form.Subscriber' | translate }}</label>
                              <input type="text" pInputText [ngModelOptions]="{standalone: true}" [(ngModel)]="formParam.subscriberId">
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                              <label>{{ 'NotificationSubscribtion.Form.Tenant' | translate }}</label>
                              <p-dropdown [options]="filterTenantOptions" [(ngModel)]="formParam.tenant" [ngModelOptions]="{standalone: true}" optionLabel="tenantName" optionValue="tenantCode"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
                              ></p-dropdown>
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                              <label>{{ 'NotificationSubscribtion.Facility' | translate }}</label>
                              <p-dropdown [options]="filterFacilityOptions" [(ngModel)]="formParam.facility" [ngModelOptions]="{standalone: true}" optionLabel="optionDesc" optionValue="optionCode"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                              </p-dropdown>
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                              <label>{{ 'NotificationSubscribtion.Forwarder' | translate }}</label>
                              <laas-dropdown [options]="filterForwarderOptions" [(ngModel)]="formParam.forwarder" [virtualScroll]="true" [virtualScrollItemSize]="40" [ngModelOptions]="{standalone: true}" optionLabel="text" optionValue="value"
                                  placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                              </laas-dropdown>
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                              <label>{{ 'NotificationSubscribtion.Customer' | translate }}</label>
                              <laas-customer-dropdown [(ngModel)]="formParam.consigneeKey" [isSingle]="true" [showClear]="true"[ngModelOptions]="{standalone: true}">
                              </laas-customer-dropdown>
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                            <label>{{ 'NotificationSubscribtion.Org' | translate }}</label>
                            <p-dropdown [options]="filterOrgIdOptions" [(ngModel)]="formParam.orgId" [ngModelOptions]="{standalone: true}"
                              optionLabel="optionDesc" optionValue="optionCode" placeholder="{{ 'Common.Message.ChooseOption' | translate }}">
                            </p-dropdown>
                          </div>
                          <div class="col-12 md:col-6 lg:col-3 mb-3">
                            <label>{{ 'NotificationSubscribtion.Form.IsSplitFile' | translate }}</label>
                            <p-dropdown [options]="fileTypeOptions" [(ngModel)]="formParam.selectedFileType" [ngModelOptions]="{standalone: true}"
                               placeholder="{{ 'Common.Message.ChooseOption' | translate }}" [showClear]="true">
                            </p-dropdown>
                          </div>
                      </div>
                      <div class="grid">
                          <div class="col">
                              <button pButton pRipple label="{{ 'Common.Button.Search' | translate }}" (click)="searchBtnClick($event)"></button>
                              <!-- <button pButton pRipple label="{{ 'Common.Button.Reset' | translate }}" (click)="resetBtnClick($event)" class="p-button-secondary ml-2"></button> -->
                          </div>
                      </div>
                  </form>
              </p-accordionTab>
          </p-accordion>
      </p-card>
    </div>
      <div class="mt-2">
          <p-table [value]="subscribeResults" class="datatable" [loading]="isLoading">
              <ng-template pTemplate="header">
                  <tr>
                      <th>#</th>
                      <th>{{ 'NotificationSubscribtion.Form.Subscriber' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.NotificationType' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.Tenant' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Facility' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Forwarder' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Customer' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.Org' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.IsPersonalSubscription' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.NotificationMode' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.Status' | translate }}</th>
                      <th>{{ 'NotificationSubscribtion.Form.IsSplitFile' | translate }}</th>
                      <th *ngIf="isShowEditColumn">{{ 'NotificationSubscribtion.Form.Action' | translate }}</th>
                  </tr>
              </ng-template>
              <ng-template pTemplate="body" let-subscribeitem let-i="rowIndex">
                  <tr>
                      <td>{{(i + 1)}}</td>
                      <td>
                          <div tooltipPosition="bottom" tooltipZIndex="99999" pTooltip="{{subscribeitem.subscriberId}}" appendTo="body">
                              {{subscribeitem.subscriberId}}
                          </div>
                      </td>
                      <td><div class="overflow-text">{{subscribeitem.notifyEventName}}</div></td>
                      <td>{{subscribeitem.tenantName}}</td>
                      <td>{{subscribeitem.facilityName}}</td>
                      <td>
                        <div tooltipPosition="bottom" tooltipZIndex="99999" pTooltip="{{subscribeitem.forwarderName}}">
                          {{subscribeitem.forwarderName}}
                        </div>
                      </td>
                      <td>
                        <div tooltipPosition="bottom" tooltipZIndex="99999" pTooltip="{{subscribeitem.customerName}}">
                              {{subscribeitem.customerName}}
                            </div>
                          </td>
                      <td>{{subscribeitem.orgName}}</td>
                      <td>{{subscribeitem.isByOwner | IsPersonalSubscription}}</td>
                      <td>{{subscribeitem.sendingMethod}}</td>
                      <td>{{subscribeitem.isActivated | Activated}}</td>
                      <td>{{subscribeitem.fileTypeFlag}}</td>
                      <td *ngIf="isShowEditColumn">
                          <i class=" pi pi-pencil " (click)="editClick($event, subscribeitem) "></i>
                          <i *ngIf="subscribeitem.isDeletable == 1" class="pi pi-trash ml-2 mt-2" (click)="deleteConfirm($event, subscribeitem.seqNo)"></i>
                      </td>
                  </tr>
              </ng-template>
          </p-table>
      </div>
  </p-card>
</div>

<p-dialog [(visible)]="isShowEditDialog " [modal]="modalConfig.modal " [draggable]="modalConfig.draggable " appendTo="body" [style]="{ width: '80%' }" [breakpoints]="{ '800px': '90%' }">
  <p-header>
      {{ 'NotificationSubscribtion.EditDialog.Title' | translate }}
      <p-inputSwitch *ngIf="editObject.isSwitchable==1 " [(ngModel)]="editObject.isChecked " class="ml-2 "></p-inputSwitch>
  </p-header>
  <div class="p-fluid formgrid grid ">
    <!-- <div class="field col-6 ">
          <label>{{ 'NotificationSubscribtion.Form.Email' | translate }}</label>
          <input pInputText type="text " [(ngModel)]="editObject.sendingTarget " [ngModelOptions]="{standalone: true} " />
      </div> -->
      <!-- <div class="field col-6 "></div> -->
      <div class="col-12 md:col-6 lg:col-6 mb-3">
          <label>{{ 'NotificationSubscribtion.Form.NotificationType' | translate }}</label>
          <p-dropdown appendTo="body" [options]="eventTypeOptions" [(ngModel)]="editObject.notifyEventSeqNo"
              [ngModelOptions]="{standalone: true}" optionLabel="text" optionValue="value"
              (onChange)="checkPersonalEmailSubscriptionStatusForEdit()"></p-dropdown>
      </div>
      <div *ngIf="editIsShowTenant" class="col-12 md:col-6 lg:col-3 mb-3 ">
          <label>{{ 'NotificationSubscribtion.Form.Tenant' | translate }}</label>
          <p-dropdown appendTo="body" [options]="tenantOptionsForEdit" [(ngModel)]="editObject.tenantCode" [ngModelOptions]="{standalone: true}" optionLabel="tenantName" optionValue="tenantCode" (onChange)="getOrgOptionsForEdit($event)"></p-dropdown>
      </div>
      <div *ngIf="editIsShowFacility" class="col-12 md:col-6 lg:col-3 mb-3 ">
          <label>{{ 'NotificationSubscribtion.Facility' | translate }}</label>
          <p-dropdown appendTo="body" [options]="facilityOptionsForEdit" [(ngModel)]="editObject.facilityCode" [ngModelOptions]="{standalone: true}" optionLabel="optionDesc" optionValue="optionCode"></p-dropdown>
      </div>
      <div *ngIf="editIsShowForwarder" class="col-12 md:col-6 lg:col-3 mb-3 ">
          <label>{{ 'NotificationSubscribtion.Forwarder' | translate }}</label>
          <laas-dropdown appendTo="body" [options]="forwarderOptionsForEdit" [(ngModel)]="editObject.forwarderCode"
              [virtualScroll]="true" [virtualScrollItemSize]="40" [ngModelOptions]="{standalone: true}" optionLabel="text"
              optionValue="value" [filter]="true" filterBy="text, value"></laas-dropdown>
      </div>
      <div *ngIf="editIsShowCustomer" class="col-12 md:col-6 lg:col-3 mb-3 ">
          <label>{{ 'NotificationSubscribtion.Customer' | translate }}</label>
          <laas-customer-dropdown [(ngModel)]="editObject.customerCode" [ngModelOptions]="{standalone: true}" [isSingle]="true" [showClear]="true">            
          </laas-customer-dropdown>
      </div>
      <div *ngIf="editIsShowOrgId" class="col-12 md:col-6 lg:col-3 mb-3 ">
        <label>{{ 'NotificationSubscribtion.Org' | translate }}</label>
        <laas-dropdown appendTo="body" [options]="orgIdOptionsForEdit" [(ngModel)]="editObject.orgId" [virtualScroll]=" true"
          optionLabel="optionDesc" optionValue="optionCode" [virtualScrollItemSize]="40" [ngModelOptions]="{standalone: true}"
          [filter]="false"></laas-dropdown>
      </div>
      <div *ngIf="editIsShowAttachFile" class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'NotificationSubscribtion.Form.IsSplitFile' | translate }}</label>
        <p-dropdown appendTo="body" [options]="fileTypeOptions" [(ngModel)]="editObject.fileTypeFlag" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
        [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" >

        </p-dropdown>
      </div>
      <div *ngIf="!isDisabledPersonalSubscriptionForEdit" class="col-12 md:col-6 lg:col-3 mb-3">
        <label>{{ 'NotificationSubscribtion.Form.IndiOrGroup' | translate }}</label>
        <div>
          <p-dropdown appendTo="body" [options]="isByOwnerOptions" [(ngModel)]="editObject.isCheckedByOwner" placeholder="{{ 'Common.Message.ChooseOption' | translate }}"
          [ngModelOptions]="{standalone: true}" placeholder="{{ 'Common.Message.ChooseOption' | translate }}" >
          </p-dropdown>
        </div>
      </div>
  </div>
  <div class="grid ">
      <div class="col ">
          <button pButton pRipple label="{{ 'Common.Button.Confirm' | translate }} " (click)="updateBtnClick($event) "></button>
      </div>
  </div>
</p-dialog>
<help-dock
  [permissionCode]="permissionCode"
  [lang]="currentLang">
</help-dock>
